import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Toggle.module.css";
/**
 * Toggle (switch) do Azim CRM.
 * Semântica ARIA: role="switch", aria-checked.
 */
export function Toggle({ checked, onChange, size = 20, disabled, "aria-label": ariaLabel, id }) {
    const trackW = size * 1.85;
    const trackH = size + 4;
    return (_jsx("button", { id: id, type: "button", role: "switch", "aria-checked": checked, "aria-label": ariaLabel, disabled: disabled, onClick: () => onChange?.(!checked), className: styles.toggle, style: {
            width: trackW,
            height: trackH,
            background: checked ? "var(--bg-accent)" : "var(--border-3)",
            justifyContent: checked ? "flex-end" : "flex-start",
        }, children: _jsx("span", { className: styles.thumb, style: { width: size, height: size } }) }));
}
//# sourceMappingURL=Toggle.js.map